export default defineNuxtPlugin({
    name: 'media',
    dependsOn: [],
    setup(nuxtApp)
    {
        const store = useMediaStore();

        Object.defineProperties(nuxtApp.vueApp.config.globalProperties, {
            mq: { configurable: true, enumerable: true, get: () => store.mq },
            phone: { configurable: true, enumerable: true, get: () => store.phone },
            tablet: { configurable: true, enumerable: true, get: () => store.tablet },
            mobile: { configurable: true, enumerable: true, get: () => store.mobile },
            laptop: { configurable: true, enumerable: true, get: () => store.laptop },
            desktop: { configurable: true, enumerable: true, get: () => store.desktop }
        });
    },
    hooks: {
        'app:mounted'()
        {
            const store = useMediaStore();

            store.setWidth(window.innerWidth);
            window.addEventListener('resize', () =>
            {
                store.setWidth(window.innerWidth);
            });
        }
    }
});

declare module '@vue/runtime-core'
{
    interface ComponentCustomProperties
    {
        mq: string;
        phone: boolean;
        tablet: boolean;
        mobile: boolean;
        laptop: boolean;
        desktop: boolean;
    }
}
